import {gsap, Observer} from "../LibrariesImport";
import {GlobalVariables} from "../GlobalVariables";

export default class Header {
	static init() {
		this.header = document.querySelector(".header-main");
		if (this.header) {
			this.navMain = this.header.querySelector(".navs");
			this.headerClass = this.header.className;
			this.keepHeaderOnMobile = this.header.dataset.keepHeaderOnMobile;
			this.toggleHeader();
			this.navMobileColor();
			this.resize();

			GlobalVariables.resizeCallbacks.push(this);
		}
	}

	static toggleHeader() {
		// let mm = gsap.matchMedia();
		// mm.add(`(min-width: ${mmMinWidth})`, () => {
		Observer.create({
			type: "scroll",
			tolerance: 30,
			dragMinimum: 30,
			onStop: () => {
				if (window.scrollY < 100) {
					this.header.classList.add("is-on-top");
					this.header.className = this.headerClass;
				} else {
					this.header.classList.remove("is-on-top");
				}
			},
			onStopDelay: 0,
			onUp: () => {
				this.showHeader();
			},
			onDown: () => {
				this.hideHeader();
			},
		});

		if (window.innerWidth > 991) {
			setTimeout(() => {
				if (window.scrollY > 100) {
					this.hideHeader();
				}
			}, 0);
		}
		// });
	}

	static hideHeader() {
		this.header.className = this.headerClass + " hide ";
	}

	static showHeader() {
		this.header.classList.remove("hide");
		this.removeClassByPrefix(this.header, 'section');
		this.header.classList.add('section');
		this.header.classList.add( this.header.dataset.sectionColor );
	}

	static navMobileColor() {
		if (window.innerWidth > 991) {
			this.removeClassByPrefix(this.navMain, 'section-color-');
		} else {
			this.navMain.classList.add(this.header.dataset.sectionColor);
		}
	}

	static makeHeaderAsBannerTheme() {
		if (this.header.classList.contains("is-on-top")) {
			this.removeClassByPrefix(this.header, 'section-color-');
			this.header.classList.add(this.header.dataset.sectionColor);
		}
	}
	// && this.header.dataset.transparentOnTop
	static restoreHeaderTheme() {
		if (this.header.classList.contains("is-on-top")) {
			this.removeClassByPrefix(this.header, 'section-color-');
			this.header.classList.add(this.header.dataset.bannerTheme);
		}
	}

	static removeClassByPrefix(node, prefix) {
		const regx = new RegExp('\\b' + prefix + '[^ ]*[ ]?\\b', 'g');
		node.className = node.className.replace(regx, '');
		return node;
	}

	static resize() {
		this.navMobileColor();
		if (window.innerWidth > 991) {
			document.body.classList.remove("navs-open");
			GlobalVariables.smoother.paused( false );
		} else {

		}
	}
}
